export const integrationsDirectCdiValidationOverrides = "/integrations/direct/cdi/validation-overrides";
